import { render, staticRenderFns } from "./DebugEditor.vue?vue&type=template&id=5fd1e1f8&scoped=true&lang=pug&"
import script from "./DebugEditor.vue?vue&type=script&lang=ts&"
export * from "./DebugEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DebugEditor.vue?vue&type=style&index=0&id=5fd1e1f8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd1e1f8",
  null
  
)

export default component.exports